import React from 'react';

type Props = {
  children: React.ReactNode[];
  style?: React.CSSProperties;
};

function ThumbnailsWrapper({ children, style }: Props) {
  return (
    <div className="grid w-64 max-w-full grid-cols-3 gap-1 md:w-96 md:grid-cols-5" style={{ ...style }}>
      {children.map((child, index) => (
        <div
          key={index}
          className="relative flex items-center justify-center rounded border border-gray-200 bg-white p-1"
        >
          <div style={{ paddingBottom: '100%' }} />
          <div className="absolute top-0 bottom-0 left-0 right-0">{child}</div>
        </div>
      ))}
    </div>
  );
}

export default ThumbnailsWrapper;
